import { render, staticRenderFns } from "./Boputu4G.vue?vue&type=template&id=93c99650&scoped=true"
import script from "./Boputu4G.vue?vue&type=script&lang=js"
export * from "./Boputu4G.vue?vue&type=script&lang=js"
import style0 from "./Boputu4G.vue?vue&type=style&index=0&id=93c99650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c99650",
  null
  
)

export default component.exports